
















































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import ApiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import Validation from '@/mixins/validation'
import apiService from '@/services/apiService'

@Component
export default class PasswordReset extends Validation {
  @Prop(String) readonly id!: string

  //   private passwordResetModel: UserPasswordModel = new UserPasswordModel()
  private valid: boolean = true
  private loading: boolean = false
  private password: string = ''
  private confirmPassword: string = ''
  private dialog: boolean = false

  private created() {
    this.$vuetify.theme.dark = true
  }

  private passwordConfirmationRule() {
    return () => this.password === this.confirmPassword || 'Password must match'
  }

  private async updatePassword(): Promise<void> {
    await apiService.postResetPassword(this.id, this.password)
    this.dialog = true
  }
}
